import * as React from 'react';
import type { SVGProps } from 'react';

const SvgPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={26}
    height={26}
    {...props}
  >
    <defs>
      <path
        id="plus_svg__a"
        d="M25.625 15.257v-4.264c0-.742-.597-1.339-1.34-1.339h-7.689v-7.69c0-.742-.597-1.339-1.34-1.339h-4.263c-.742 0-1.339.597-1.339 1.34v7.689h-7.69c-.742 0-1.339.597-1.339 1.34v4.263c0 .742.597 1.339 1.34 1.339h7.689v7.69c0 .742.597 1.339 1.34 1.339h4.263c.742 0 1.339-.597 1.339-1.34v-7.689h7.69c.742 0 1.339-.597 1.339-1.34Z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <use xlinkHref="#plus_svg__a" fill="#000" fillRule="nonzero" />
        <g mask="url(#plus_svg__mask-2)">
          <path d="M-1.429-1.429h32.857v32.857H-1.429z" />
        </g>
      </g>
    </g>
  </svg>
);
export default SvgPlus;
